import { Button } from "primereact/button";
import { toast } from "react-toastify";
import { useTranslation } from "@i18n/hooks";
// import { useMutation } from "react-relay";
// import { RESET_STAGING_BILLING_MUTATION } from "./reset-staging-billing-button.graphql";

export const ResetStagingBillingButton = () => {
	const { t } = useTranslation("common");
	// const [resetStagingBilling, isResettingStagingBilling] = useMutation(
	// 	RESET_STAGING_BILLING_MUTATION,
	// );

	const handleOnClick = () => {
		toast.error("Implement");
		// resetStagingBilling({
		// 	variables: {},
		// 	onCompleted: () => {
		// 		toast.success("Staging-Billing zurückgesetzt");
		// 	},
		// });
	};

	return (
		<Button
			className={"mb-2"}
			label={t("staging.resetBilling")}
			// disabled={isResettingStagingBilling}
			onClick={handleOnClick}
		/>
	);
};
